import React from 'react';
import '../styles/experience.css'; // Import the CSS for styling

const Experience = () => {
    const experiences = [
        {
            role: "AI Engineer Internship",
            company: "PM Accelerator",
            location: "United States of America",
            dates: "Jan 2026 – Mar 2026",
            responsibilities: [
                "Developed and integrated AI/ML solutions using Python, FastAPI, and LLM APIs, building scalable backend services for intelligent applications.",
                "Fine-tuned Transformer-based and LLM models using Hugging Face, PyTorch, and parameter-efficient techniques such as LoRA/QLoRA, preparing datasets and evaluating model performance.",
                "Built RAG pipelines using document processing, embeddings, vector databases, and prompt engineering to deliver context-aware AI responses."
            ]
        },
        {
            role: "Software Engineer",
            company: "Cedargate Technologies Inc.",
            location: "Sanepa, Lalitpur Nepal",
            dates: "Mar 2023 – Aug 2023",
            responsibilities: [
                "Implemented AWS Step Functions to orchestrate complex workflows and ensure reliable execution of long-running processes.",
                "Worked on a microservice architecture to develop, automate, and integrate different projects, jobs, and APIs.",
                "Developed a migration script module in Python for migrating internal tickets from the Target process to Salesforce and client tickets to Jira.",
                "Developed a migration script in Python for migrating Redmine tickets to Jira.",
                "Led the team to write integration scripts in Groovy to establish an automated two-way sync between Salesforce and Jira using ScriptRunner for Jira and Simple Salesforce API.",
                "Written stored procedures and developed job modules to automate sending SLA reports every month to clients.",
                "Responded to client-related questions, including support and feature requests, and provided assistance where needed."
            ]
        },
        {
            role: "Associate Software Engineer",
            company: "Cedargate Technologies Inc.",
            location: "Sanepa, Lalitpur Nepal",
            dates: "Feb 2022 – Mar 2023",
            responsibilities: [
                "Led the team and worked on merging multiple consolidated cloud instances into a single data center, helping the company save around 50% of its annual cost in Jira & Confluence.",
                "Developed complete front-end services using React JS and wrote backend REST APIs and functionalities using Python, Node.js, and Groovy on Grails.",
                "Got familiar with Salesforce, Redmine, HIPAA, AWS, React JS, Redux, and Node.js.",
                "Helped around 1000 employees solve Jira issues, create smooth workflows, write scripts to automate daily tasks, and manage permissions across projects and active directories.",
                "Helped clients with everyday queries and concerns and solved their issues in a timely manner."
            ]
        },
        {
            role: "Software Developer Internship",
            company: "Tangobango Technologies",
            location: "Sanepa, Lalitpur Nepal",
            dates: "Mar 2021 – Sep 2021",
            responsibilities: [
                "Designed, developed, and tested applications and APIs for devices.",
                "Implemented the backend business layers using Spring Boot and the front end using React JS.",
                "Developed a Point of Sale System for restaurants."
            ]
        }
    ];


    // Group experiences by company name
    const groupedExperiences = experiences.reduce((acc, exp) => {
        const companyKey = exp.company || 'Freelance'; // If no company, group under 'Freelance'
        if (!acc[companyKey]) acc[companyKey] = [];
        acc[companyKey].push(exp);
        return acc;
    }, {});

    return (
            <div className="experience-content">
                <div className="experience-list">
                    {Object.keys(groupedExperiences).map((company, index) => (
                        <div key={index} className="experience-item">
                            <div className="experience-header">
                                <h3>{company}</h3>
                                {groupedExperiences[company][0]?.location && (
                                    <span>{groupedExperiences[company][0].location}</span>
                                )}
                            </div>
                            {groupedExperiences[company].map((exp, idx) => (
                                <div key={idx}>
                                    <div>
                                        <h4>{exp.role}</h4>
                                        <p className="experience-dates">{exp.dates}</p>
                                        <ul className="responsibilities">
                                            {exp.responsibilities.map((responsibility, i) => (
                                                <li key={i}>{responsibility}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                            {index < Object.keys(groupedExperiences).length - 1 && <div className="company-separator"></div>}
                        </div>
                    ))}
                </div>
            </div>
    );
};

export default Experience;
